<template>
    <div class="home-view">
        <Topbar />
        <div class="container-fluid text-left pl-2 pr-2 d-flex justify-content-center mt-4 pt-4">
            <div class="card shadow mb-4 col-md-6 m-0 p-0 text-secondary" v-if="this.produto">
                <div class="card small">
                    <div class="card-header text-white text-center p-1" :style="{ backgroundColor: moduloAtual().color }">
                        DETALHES DO PRODUTO
                    </div>
                    <div class="card-body p-2">
                        <ul class="nav nav-tabs small" id="myTab">
                            <li class="nav-item">
                                <a class="nav-link active" id="tab1-tab" data-toggle="tab" href="#tab1" role="tab">DETALHES</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="tab2-tab" data-toggle="tab" href="#tab2" role="tab">ESTOQUE</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="tab3-tab" data-toggle="tab" href="#tab3" role="tab">HISTÓRICO</a>
                            </li>
                        </ul>
                        <div class="tab-content mt-3" id="myTabContent">
                            <div class="tab-pane fade show active" id="tab1" role="tabpanel">
                                <div class="card small">
                                    <div class="card-header small text-center bg-secondary text-white p-1">
                                        <span class="font-weight-bold">
                                            DADOS PRINCIPAIS DO PRODUTO
                                        </span>
                                    </div>
                                    <div class="card-body p-2">
                                        <div class="row">
                                            <div class="col-12">
                                                <label for="descricao">DESCRIÇÃO</label>
                                                <input type="text" readonly id="descricao" :value="produto.descricao" class="form-control form-control-sm mb-1 text-danger">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6 pr-1">
                                                <label for="sku">SKU</label>
                                                <input type="text" readonly id="sku" :value="produto.sku" class="form-control form-control-sm mb-1 text-danger">
                                            </div>
                                            <div class="col-6 pl-1">
                                                <label for="codbarras">PRODUTO</label>
                                                <input type="text" readonly id="codbarras" :value="produto.codbarras" class="form-control form-control-sm mb-1 text-danger">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6 pr-1">
                                                <label for="qtde_estoque">Qtde Estoque</label>
                                                <input type="text" readonly id="qtde_estoque" :value="produto.qtde_estoque" class="form-control form-control-sm mb-1">
                                            </div>
                                            <div class="col-6 pl-1">
                                                <label for="fatorqtde">Fator Qtde</label>
                                                <input type="text" readonly id="fatorqtde" :value="produto.fatorqtde" class="form-control form-control-sm mb-1">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6 pr-1">
                                                <label for="possuivalidade">Validade</label>
                                                <input type="text" readonly id="possuivalidade" :value="produto.possuivalidade === 'S' ? 'SIM' : 'NÃO'" class="form-control form-control-sm mb-1">
                                            </div>
                                            <div class="col-6 pl-1">
                                                <label for="serialnumber">Serial number</label>
                                                <input type="text" readonly id="serialnumber" :value="produto.serialnumber === 'S' ? 'SIM' : 'NÃO'" class="form-control form-control-sm mb-1">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6 pr-1">
                                                <label for="codigofabricante">CÓDIGO FABRICANTE</label>
                                                <input type="text" readonly id="codigofabricante" :value="produto.codigofabricante" class="form-control form-control-sm mb-1 text-danger">
                                            </div>
                                            <div class="col-6 pl-1">
                                                <label for="codigoprodutoabacos">Cod.abacos / Cod. interno</label>
                                                <input type="text" readonly id="codigoprodutoabacos" :value="produto.codigoprodutoabacos" class="form-control form-control-sm mb-1 text-danger">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6 pr-1">
                                                <label for="codgrupoproduto">Cod. grupo produto</label>
                                                <input type="text" readonly id="codgrupoproduto" :value="produto.codgrupoproduto" class="form-control form-control-sm mb-1 text-danger">
                                            </div>
                                            <div class="col-6 pl-1">
                                                <label for="valorcusto">Valor/custo</label>
                                                <input type="text" readonly id="valorcusto" :value="produto.valorcusto" class="form-control form-control-sm mb-1">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6 pr-1">
                                                <label for="mov_estoque">Movimenta estoque</label>
                                                <input type="text" readonly id="mov_estoque" :value="produto.mov_estoque === 'S' ? 'SIM' : 'NÃO'" class="form-control form-control-sm mb-1">
                                            </div>
                                            <div class="col-6 pl-1">
                                                <label for="ativo">Ativo</label>
                                                <input type="text" readonly id="ativo" :value="produto.ativo === 'S' ? 'SIM' : 'NÃO'" class="form-control form-control-sm mb-1">
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <div class="card small mt-2">
                                    <div class="card-header small text-center bg-secondary text-white p-1">
                                        <span class="font-weight-bold">
                                            DETALHES DO PRODUTO
                                        </span>
                                    </div>
                                    <div class="card-body p-2">

                                        <div class="row">
                                            <div class="col-6 pr-1">
                                                <label for="codigoprodutopai">Cod. produto pai</label>
                                                <input type="text" readonly id="codigoprodutopai" :value="produto.codigoprodutopai" class="form-control form-control-sm mb-1 text-danger">
                                            </div>
                                            <div class="col-6 pl-1">
                                                <label for="codigobarrasfabricante">Cod. CX fabricante</label>
                                                <input type="text" readonly id="codigobarrasfabricante" :value="produto.codigobarrasfabricante" class="form-control form-control-sm mb-1 text-danger">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-12">
                                                <label for="unidademedida">Unidade de medida</label>
                                                <input type="text" readonly id="unidademedida" :value="produto.unidademedida" class="form-control form-control-sm mb-1">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6 pr-1">
                                                <label for="codbarrascaixa">Cod.barras CX</label>
                                                <input type="text" readonly id="codbarrascaixa" :value="produto.codbarrascaixa" class="form-control form-control-sm mb-1 text-danger">
                                            </div>
                                            <div class="col-6 pl-1">
                                                <label for="comprimento">Comprimento</label>
                                                <input type="text" readonly id="comprimento" :value="produto.comprimento" class="form-control form-control-sm mb-1">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6 pr-1">
                                                <label for="pesoliquido">Peso liquido</label>
                                                <input type="text" readonly id="pesoliquido" :value="produto.pesoliquido" class="form-control form-control-sm mb-1">
                                            </div>
                                            <div class="col-6 pl-1">
                                                <label for="comprimento">Comprimento</label>
                                                <input type="text" readonly id="comprimento" :value="produto.comprimento" class="form-control form-control-sm mb-1">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6 pr-1">
                                                <label for="pesoliquido">Peso liquido</label>
                                                <input type="text" readonly id="pesoliquido" :value="produto.pesoliquido" class="form-control form-control-sm mb-1">
                                            </div>
                                            <div class="col-6 pl-1">
                                                <label for="pesobruto">Peso bruto</label>
                                                <input type="text" readonly id="pesobruto" :value="produto.pesobruto" class="form-control form-control-sm mb-1">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6 pr-1">
                                                <label for="altura">Altura</label>
                                                <input type="text" readonly id="altura" :value="produto.altura" class="form-control form-control-sm mb-1">
                                            </div>
                                            <div class="col-6 pl-1">
                                                <label for="largura">Largura</label>
                                                <input type="text" readonly id="largura" :value="produto.largura" class="form-control form-control-sm mb-1">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6 pr-1">
                                                <label for="qtdeminima">Qtde minima</label>
                                                <input type="text" readonly id="qtdeminima" :value="produto.qtdeminima" class="form-control form-control-sm mb-1">
                                            </div>
                                            <div class="col-6 pl-1">
                                                <label for="qtdemaxima">Qtde maxima</label>
                                                <input type="text" readonly id="qtdemaxima" :value="produto.qtdemaxima" class="form-control form-control-sm mb-1">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <br>
                            </div>
                            <div class="tab-pane fade small" id="tab2" role="tabpanel">
                                <h6 class="text-center">ESTOQUE</h6>
                                <div class="table-responsive">
                                    <table class="table table-bordered table-striped small">
                                        <caption class="d-none"></caption>
                                        <thead>
                                            <th class="p-1">ENDERECO</th>
                                            <th class="p-1">QTDE</th>
                                            <th class="p-1">TIPO</th>
                                            <th class="p-1">END.QUA</th>
                                            <th class="p-1">PULMÃO</th>
                                            <th class="p-1">PROD.QUA</th>
                                            <th class="p-1">DATA</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item) in produto.estoques_com_quantidade" :key="item.idenderecamento">
                                                <td class="small p-1">{{ item.descricao }}</td>
                                                <td class="p-1">{{ item.qtde }}</td>
                                                <td class="p-1">{{ item.tipo }}</td>
                                                <td class="p-1">{{ item.endereco_quarentena }}</td>
                                                <td class="p-1">{{ item.pulmao }}</td>
                                                <td class="p-1">{{ item.quarentena }}</td>
                                                <td class="p-1">{{ dateFormat(item.datagravacao) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <br>
                                <h6 class="text-center">OUTROS ENDEREÇOS</h6>
                                <div class="table-responsive">
                                    <table class="table table-bordered table-striped small">
                                        <caption class="d-none">Outros endereços</caption>
                                        <thead>
                                            <th class="p-1">ENDERECO</th>
                                            <th class="p-1">QTDE</th>
                                            <th class="p-1">TIPO</th>
                                            <th class="p-1">END.QUA</th>
                                            <th class="p-1">PULMÃO</th>
                                            <th class="p-1">PROD.QUA</th>
                                            <th class="p-1">DATA</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item) in produto.estoques_sem_quantidade" :key="item.idenderecamento">
                                                <td class="small p-1">{{ item.descricao }}</td>
                                                <td class="p-1">{{ item.qtde }}</td>
                                                <td class="p-1">{{ item.tipo }}</td>
                                                <td class="p-1">{{ item.endereco_quarentena }}</td>
                                                <td class="p-1">{{ item.pulmao }}</td>
                                                <td class="p-1">{{ item.quarentena }}</td>
                                                <td class="p-1">{{ dateFormat(item.datagravacao) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <br>
                                <br>
                            </div>
                            <div class="tab-pane fade small" id="tab3" role="tabpanel">

                                <div class="row small mb-2">
                                    <div class="col-4 pr-1">
                                        <button :class="tipoHistoricoSelecionado === 'produto' ? 'btn btn-sm btn-block btn-success' : 'btn btn-sm btn-block btn-primary'" style="font-size: 8px;" @click="selecionaTipoHistorico('produto')">
                                            PRODUTO
                                        </button>
                                    </div>
                                    <div class="col-4 pl-1 pr-1">
                                        <button :class="tipoHistoricoSelecionado === 'movimentacao' ? 'btn btn-sm btn-block btn-success' : 'btn btn-sm btn-block btn-primary'" style="font-size: 8px;" @click="selecionaTipoHistorico('movimentacao')">
                                            MOVIMENTAÇÃO
                                        </button>
                                    </div>
                                    <div class="col-4 pl-1">
                                        <button :class="tipoHistoricoSelecionado === 'alteracao' ? 'btn btn-sm btn-block btn-success' : 'btn btn-sm btn-block btn-primary'" style="font-size: 8px;" @click="selecionaTipoHistorico('alteracao')">
                                            ALTERAÇÃO
                                        </button>
                                    </div>
                                </div>

                                <div  v-if="this.tipoHistoricoSelecionado === 'produto'">
                                    
                                    <div class="card">
                                        <div class="card-body p-2">
                                            <div class="text-center h6">
                                                <em class="fa fa-circle mr-2 text-success"></em>
                                                <span>ENTRADA</span>

                                                <em class="fa fa-circle mr-2 ml-4 text-warning"></em>
                                                <span>SAÍDA</span>
                                            </div>
                                        </div>
                                    </div>

                                    <table class="table table-bordered table-striped mt-2 small">
                                        <caption class="d-none"></caption>
                                        <thead>
                                            <th class="p-1">TIPO</th>
                                            <th class="p-1">QTDE</th>
                                            <th class="p-1">SALDO ANTERIOR</th>
                                            <th class="p-1">DATA</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item) in produto.historico_produto" :key="item.idenderecamento">
                                                <td :class="item.entradasaida === 'E' ? 'p-1 bg-success' : 'p-1 bg-warning'">{{ item.tipo }}</td>
                                                <td :class="item.entradasaida === 'E' ? 'p-1 bg-success' : 'p-1 bg-warning'">{{ item.qtde }}</td>
                                                <td :class="item.entradasaida === 'E' ? 'p-1 bg-success' : 'p-1 bg-warning'">{{ item.saldoanterior }}</td>
                                                <td :class="item.entradasaida === 'E' ? 'p-1 bg-success' : 'p-1 bg-warning'">{{ dateFormat(item.datamovimento) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br>
                                    <br>
                                </div>

                                <div  v-if="this.tipoHistoricoSelecionado === 'movimentacao'">
                                    
                                    <div class="card">
                                        <div class="card-body p-2">
                                            <div class="text-center h6">
                                                <em class="fa fa-circle mr-2 text-success"></em>
                                                <span>ENTRADA</span>

                                                <em class="fa fa-circle mr-2 ml-4 text-warning"></em>
                                                <span>SAÍDA</span>
                                            </div>
                                        </div>
                                    </div>

                                    <table class="table table-bordered table-striped mt-2 small">
                                        <caption class="d-none"></caption>
                                        <thead>
                                            <th class="p-1">TIPO</th>
                                            <th class="p-1">QTDE</th>
                                            <th class="p-1">SALDO ANTERIOR</th>
                                            <th class="p-1">DATA</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item) in produto.historico_movimentacao" :key="item.idenderecamento">
                                                <td :class="item.entradasaida === 'E' ? 'p-1 bg-success' : 'p-1 bg-warning'">{{ item.tipo }}</td>
                                                <td :class="item.entradasaida === 'E' ? 'p-1 bg-success' : 'p-1 bg-warning'">{{ item.qtde }}</td>
                                                <td :class="item.entradasaida === 'E' ? 'p-1 bg-success' : 'p-1 bg-warning'">{{ item.saldoanterior }}</td>
                                                <td :class="item.entradasaida === 'E' ? 'p-1 bg-success' : 'p-1 bg-warning'">{{ dateFormat(item.datamovimento) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br>
                                    <br>
                                </div>

                                <div  v-if="this.tipoHistoricoSelecionado === 'alteracao'">
                                    
                                    <table class="table table-bordered table-striped mt-2 small">
                                        <caption class="d-none"></caption>
                                        <thead>
                                            <th class="p-1">DETALHES</th>
                                            <th class="p-1">USUÁRIO</th>
                                            <th class="p-1">DATA</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item) in produto.historico_alteracao" :key="item.idenderecamento">
                                                <td class="p-1">{{ item.detalhes }}</td>
                                                <td class="p-1">{{ item.usuario }}</td>
                                                <td class="p-1">{{ dateFormat(item.dataalteracao) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br>
                                    <br>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <LogoutModal />
        <FooterBar />
    </div>
</template>
  
  
<script>
    // @ is an alias to /src
    import Topbar from '@/components/Topbar.vue'
    import FooterBar from '@/components/FooterBar.vue'
    import LogoutModal from '@/components/LogoutModal.vue'
    import ViewMixin from './ViewMixin'
    import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'
    import api, { getUsername, getPerfil } from '../services/api'
    import { dateFormat } from '../utils';
  
  export default {
    name: 'ConsultaProdutoResultado',
    mixins: [
        ViewMixin
    ],
    components: {
        Topbar,
        LogoutModal,
        FooterBar
    },
  
    data: () => {
        return {
            produto: null,
            tipoHistoricoSelecionado: 'produto',
        };
    },
  
    async mounted() {
        try {
            await this.validarToken();
            await this.getDetalhesProduto();
        } catch (e) {
            if (e instanceof TokenInvalidoException) {
                this.handleTokenInvalidoException();
            } else if (e instanceof ServerErrorException) {
                alert(e.message);
            } else {
                alert(DEFAULT_ERROR_MESSAGE);
            }      
        }
    },
  
    methods: {
        getUsername,
        getPerfil,
        dateFormat,

        async validarToken() {
            this.carregando = true;
    
            await api.get("/validar-token");
    
            this.carregando = false;
        },

        async getDetalhesProduto() {
            this.carregando = true;
            try {
                let result  = await api.post("/pesquisa/produto/detalhes", {idProduto: this.$route.params.idproduto});
                this.produto = result.data.detalhes;
            } catch (error) {
                console.log(error);
            }
            this.carregando = false;
        },

        selecionaTipoHistorico(tipo) {
            this.tipoHistoricoSelecionado = tipo;
        },
    }
  }
</script>
  
<style scoped lang="scss">    
  
    .home-view {
      height: 100%;
    }
  
    .container-img {
      height: auto;
      display: flex;
      justify-content: center;
      align-self: center;
    }

    .form-control-sm {
        font-size: 9px;
        height: 16px;
    }

    label {
        margin: 0px;
    }
</style>